import gql from "graphql-tag";

export const GET_CASE_DETAILS = gql`
  query getCaseDetails($caseNumber: String!, $formId: String!) {
    getCaseDetails(caseNumber: $caseNumber, formId: $formId) {
      caseDetails {
        userId
        formId
        formVersionId
        visaType
        applicationId
        caseNumber
        caseStatus
        externalStatus
        jobBeginDate
        determinationExpDate

        empBusinessName
        jobTitle
        dateSubmitted
        jobBeginDate
        jobEndDate
        extensionRequestDate
        isExtensionRequested
        isExtensionApproved
        foreign_worker_name
        appealsReceiptDate

        occupationType
        jobOppPwdNumber
        primaryWorksiteCity
        primaryWorksiteState
        appealsReceiptDate
        noadIssuedDate
        balcaTransmittalDate
        balcaDecisionIssuedDate

        inspectionStatus

        eventDetails {
          actionType
          updatedCaseStatus
          eventId
          dateCompleted
        }

        hasActiveInspNotification
        housingAddr1
        housingAddr2
        housingCity
        housingState
        housingPostcode
        housingCounty
        housingType
        housingAddInfo
        housingInformationId
        inspectionIndividualId
        housingTotalUnits
        housingTotalOccupy
        housingCompLocal
        housingCompState
        housingCompFederal
        isComplianceSwa
        isComplianceOther
        complianceOtherText
        housingInspectionNotes {
          category
          inspectionTitle
          inspectionNote
          createdDate
          modifiedDate
        }

        housingLocations {
          addmbHousingTotalUnits
          addmbHousingTotalOccupy
          addmbHousingComplyLocal
          addmbHousingComplyState
          addmbHousingComplyFederal
          addmbComplianceOtherText
          addmbIsComplianceSwa
          addmbIsComplianceOther
          addmbHousingType
          addmbHousingAddr1
          addmbHousingAddr2
          addmbHousingCity
          addmbHousingState
          addmbHousingPostcode
          addmbHousingCounty
          addmbHousingAdditionalInfo
          inspectionIndividualId
          inspectionGeneralId
          inspectionStatus
          inspectionCompletionDate
          inspectionCreatedDate
          inspectionModifiedDate
          hasActiveInspNotification
          housingInspectionNotes {
            category
            inspectionTitle
            inspectionNote
            createdDate
            modifiedDate
          }
        }

        caseMetadata {
          caseOwner
          randomizationInfo
          determinationDate
        }

        docs {
          docName
          docCategory
          docCreatedDate
          submittedBy
          dhDocId
          caseNumber
          inspectionIndividualId
        }
      }
      caseActionHistory {
        case_action_done
        case_action_done_detailed {
          action
          timestamp
          externalStatus
        }
        case_action_records {
          action
          timestamp
          externalStatus
          email
          actorName
          docs
        }
      }
      isPostDeterminationAvailable
    }
  }
`;
